import React from 'react';
import { MetricsElement } from 'react-metrics';

import FacetCheckbox from '../../search-filter/components/facet-checkbox';
import ProductRating from '../../product/components/product-rating';

export default ({
    filterName,
    field,
    options,
    onClick = () => {},
    metricsId,
    onFilterClick,
    useAlias = false,
    isV2,
    align,
    isFilterSelected
}) => {
    if (options) {
        return (
            <React.Fragment>
                {options.map((opt, i) => {
                    if (opt) {
                        let {
                            displayName,
                            selected,
                            count,
                            _id,
                            pgKey,
                            type,
                            value = {},
                            alias,
                        } = opt;
                        let { text } = value;
                        let queryValue = {
                            [`facets.${field}`]: useAlias ? alias : _id,
                        };
                        let filterSelected = typeof isFilterSelected === 'function' ? isFilterSelected(opt, field) : selected;
                        return (
                            <li className={`facet-value facet-${type}`} key={i}>
                                <MetricsElement
                                    element={isV2 ? 'div' : "button"}
                                    className={`facet-value-detail unstyled ${
                                        count == 0 ? ' disabled' : ''
                                    }`}
                                    aria-label={displayName}
                                    tabIndex={isV2 ?  -1: 0 }
                                    data-metrics-event-name="searchFilter"
                                    data-metrics-event="e_facet"
                                    data-metrics-filter-checked={!filterSelected}
                                    data-metrics-filter-categories={`${
                                        metricsId ? metricsId + ':' : ''
                                    }${filterName}`}
                                    data-metrics-filter-value={displayName}
                                    onClick={() => {
                                        if (count === 0) {
                                            return;
                                        }
                                        onClick(
                                            filterSelected ? 'remove' : 'add',
                                            queryValue
                                        );
                                        onFilterClick &&
                                            onFilterClick(queryValue);
                                    }}
                                >
                                    <FacetCheckbox
                                        type={type}
                                        selected={filterSelected}
                                        displayName={displayName}
                                        count={count}
                                        value={text}
                                        isV2={isV2}
                                        align={align}
                                    />
                                </MetricsElement>
                            </li>
                        );
                    } else {
                        return null;
                    }
                })}
            </React.Fragment>
        );
    } else {
        return null;
    }
};

export const CustomRatingOptions = ({
    filterName,
    field,
    options,
    onClick = () => {},
    metricsId,
    onFilterClick,
    useAlias = false,
    isV2,
    align
}) => {
    if (options) {
        return (
            <React.Fragment>
                {options.map((opt, i) => {
                    if (opt) {
                        let {
                            displayName,
                            selected,
                            count,
                            _id,
                            type,
                            value = {},
                            alias
                        } = opt;
                        let { text } = value;
                        let queryValue = {
                            [`${field}`]: useAlias ? alias : _id,
                        };
                        let rating = text * 1;

                        return (
                            <li className={`facet-value facet-${type}`} key={i}>
                                <MetricsElement
                                    element={isV2 ? 'div' : "button"}
                                    className={`facet-value-detail unstyled ${
                                        count == 0 ? ' disabled' : ''
                                    }`}
                                    aria-label={displayName}
                                    tabIndex={isV2 ?  -1: 0 }
                                    data-metrics-event-name="searchFilter"
                                    data-metrics-event="e_facet"
                                    data-metrics-filter-checked={!selected}
                                    data-metrics-filter-categories={`${
                                        metricsId ? metricsId + ':' : ''
                                    }${filterName}`}
                                    data-metrics-filter-value={displayName}
                                    onClick={() => {
                                        if (count === 0) {
                                            return;
                                        }
                                        onClick(
                                            selected ? 'remove' : 'replace',
                                            queryValue
                                        );
                                        onFilterClick &&
                                            onFilterClick(queryValue);
                                    }}
                                >
                                    <FacetCheckbox
                                        type={type}
                                        selected={selected}
                                        count={count}
                                        value={text}
                                        isV2={isV2}
                                        align={align}
                                    >
                                        <ProductRating rating={rating} />
                                        {rating < 5 && rating > 0 && ' & Up'}
                                    </FacetCheckbox>
                                </MetricsElement>
                            </li>
                        );
                    } else {
                        return null;
                    }
                })}
            </React.Fragment>
        );
    } else {
        return null;
    }
};
